import { render } from "./BrandPocEditors.vue?vue&type=template&id=41aa55aa&scoped=true"
import script from "./BrandPocEditors.vue?vue&type=script&lang=js"
export * from "./BrandPocEditors.vue?vue&type=script&lang=js"

import "./BrandPocEditors.vue?vue&type=style&index=0&id=41aa55aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41aa55aa"]])

export default __exports__